import { Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import toast from 'react-hot-toast';
import VyTextField from './VyTextField';

interface VyCopyFieldProps {
  value: string;
  successMessage?: string;
}
export const VyCopyField = ({ value, successMessage }: VyCopyFieldProps) => {
  const { t } = useTranslation(['account']);

  return (
    <div className="flex space-x-3">
      <VyTextField color="secondary" value={value} fullWidth />
      <Button
        onClick={() => {
          navigator.clipboard.writeText(value);
          successMessage && toast.success(successMessage);
        }}
        variant="outlined"
        color="secondary">
        {t('account:copy')}
      </Button>
    </div>
  );
};
